import * as actionTypes from "../constants/actionTypes";
import { PORTAL_IDS } from "../constants/portals";

const portalId = (state = PORTAL_IDS.nlTelecom, action) => {
  switch (action.type) {
    case actionTypes.SWITCH_PORTAL:
      if (PORTAL_IDS[action.portalId]) return action.portalId;
      else return state;
    default:
      return state;
  }
};

export default portalId;
